<template>
  <custom-field-input-base-old
    single-line
    :field="field"
    v-model="value"
    type="email"></custom-field-input-base-old>
</template>

<script>
import customFieldTypeMixinOld from '@/modules/custom_fields/mixins/customFieldTypeMixinOld';

export default {
  name: 'custom-field-email-old',
  mixins: [customFieldTypeMixinOld]
};
</script>
